import { Box } from '@osmosis/tailwind-ui/components/Box';
import { bg100 } from '@osmosis/tailwind-ui/styles/background';
import React from 'react';
import dayjs from 'dayjs';
import { textClasses500 } from '@osmosis/react-ui/styles/classes';

type Props = {
  date: string;
};

/**
 * The published date chip.
 */
const PublishedDate = ({ date }: Props) => {
  return (
    <Box cn="flex">
      <Box cn={`${bg100} p-1 px-2 rounded-lg text-sm ${textClasses500}`}>
        {dayjs(date).format('MM-DD-YYYY')}
      </Box>
    </Box>
  );
};

export default PublishedDate;
